import React, { useEffect, useState } from "react";
import { Card, Paragraph, Text } from "theme-ui";
import { Decimal, LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";
import { InfoIcon } from "../../InfoIcon";
import { useLiquity } from "../../../hooks/LiquityContext";
import { Badge } from "../../Badge";
import { fetchPrices } from "../context/fetchPrices";
import { reservesAndSupply } from "../../Farm/context/fetchPrices";

const selector = ({
  remainingLiquidityMiningLQTYReward3,
  totalStakedUniTokens3,
  price
}: LiquityStoreState) => ({
  remainingLiquidityMiningLQTYReward3,
  totalStakedUniTokens3,
  price
});

export const Yield: React.FC = () => {
  const {
    liquity: {
      connection: { addresses, liquidityMiningLQTYRewardRate }
    }
  } = useLiquity();

  let { remainingLiquidityMiningLQTYReward3, totalStakedUniTokens3, price } = useLiquitySelector(selector);
  totalStakedUniTokens3 = totalStakedUniTokens3.div(1e10)

  const [lqtyPrice, setLqtyPrice] = useState<Decimal | undefined>(undefined);
  const [uniLpPrice, setUniLpPrice] = useState<Decimal | undefined>(undefined);
  const hasZeroValue = remainingLiquidityMiningLQTYReward3.isZero || totalStakedUniTokens3.isZero;
  const lqtyTokenAddress = addresses["lqtyToken"];
  const uniTokenAddress = addresses["uniToken3"];
  const secondsRemaining = remainingLiquidityMiningLQTYReward3.div(liquidityMiningLQTYRewardRate);
  const daysRemaining = secondsRemaining.div(60 * 60 * 24);

  useEffect(() => {
    (async () => {
      try {
        const tokensPrice = JSON.parse(localStorage.getItem('tokensPrice') || '{}');
        const flexPrice = tokensPrice.FLEX || 0;
        const plsxPrice = tokensPrice.PLSX || 0;
        const earnPrice = tokensPrice.EARN || 0;

        const { reservesData, totalSupply } = await reservesAndSupply(uniTokenAddress);
        let totalSupply1 = Number(totalSupply)/1e18;
        let reservesData1 = reservesData;
        let reserve0 = Number(reservesData1[0])/1e18
        let reserve1 = Number(reservesData1[1])/1e18

        const LpPrice = (reserve0 * Number(plsxPrice) + reserve1 * earnPrice) / totalSupply1;

        setLqtyPrice(Decimal.from(flexPrice));
        setUniLpPrice(Decimal.from(LpPrice));
      } catch (error) {
        console.error(error);
      }
    })();
  }, [lqtyTokenAddress, uniTokenAddress]);


  if (hasZeroValue || lqtyPrice === undefined || uniLpPrice === undefined) return null;

  const remainingLqtyInUSD = remainingLiquidityMiningLQTYReward3.mul(lqtyPrice);
  const totalStakedUniLpInUSD = totalStakedUniTokens3.mul(uniLpPrice);
  const yieldPercentage = remainingLqtyInUSD.div(totalStakedUniLpInUSD).mul(100);

  if (yieldPercentage.isZero) return null;

  return (
    <Badge>
      <Text>
        {daysRemaining?.prettify(0)} day yield {yieldPercentage.toString(2)}%
      </Text>
      <InfoIcon
        tooltip={
          <Card variant="tooltip" sx={{ minWidth: ["auto", "352px"] }}>
            <Paragraph>
              An <Text sx={{ fontWeight: "bold" }}>estimate</Text> of the FLEX return on staked PulseX
              LP tokens. The farm runs for 369 days, and the return is relative to the time remaining.
            </Paragraph>
            <Paragraph sx={{ fontSize: "12px", fontFamily: "monospace", mt: 2 }}>
              ($FLEX_REWARDS / $STAKED_PulseX_LP) * 100 ={" "}
              <Text sx={{ fontWeight: "bold" }}> Yield</Text>
            </Paragraph>
            <Paragraph sx={{ fontSize: "12px", fontFamily: "monospace" }}>
              ($
              {remainingLqtyInUSD.shorten()} / ${totalStakedUniLpInUSD.shorten()}) * 100 =
              <Text sx={{ fontWeight: "bold" }}> {yieldPercentage.toString(2)}%</Text>
            </Paragraph>
          </Card>
        }
      ></InfoIcon>
    </Badge>
  );
};